import { combineReducers } from '@reduxjs/toolkit';
import listSlice from './list/listSlice';
import viewSlice from './view/viewSlice';

const submittalsSlice = combineReducers({
    list: listSlice,
    view: viewSlice,
});

export default submittalsSlice;
